import supportChatQueries from "$/lib/queries/support-chat-queries"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  threadId: z.string().uuid("Ogiltigt tråd-ID"),
})

export const Route = createFileRoute("/(app)/_auth/support-chat/$threadId")({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ threadId }) => ({ threadId: `${threadId}` }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(supportChatQueries.adminMessages(params.threadId))
  },
})
